export const experienceData = [
  {
    company: 'State Street Investment Management',
    role: 'Spring Asset Management Analyst',
    roleVi: 'Chuyên viên Phân tích Quản lý Tài sản Mùa Xuân',
    location: 'Boston, MA',
    locationVi: 'Boston, MA',
    dates: 'Jan 2026 – Jun 2026',
    datesVi: 'Tháng 1/2026 – Tháng 6/2026',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/agta6duKEorKsUKqpfgzbc/StateStreetIM.jpg',
    description: [
      'Structured ETF wrappers for Blackstone, Apollo, JPMorgan, and BlackRock at a $5T+ global asset manager',
      'Managed seed funding for newly launched ETFs, working cross-functionally to secure launch capital',
      'Structured derivative hedges to neutralize market risk for new ETF products',
    ],
    descriptionVi: [
      'Cấu trúc ETF wrapper cho Blackstone, Apollo, JPMorgan và BlackRock tại công ty quản lý tài sản toàn cầu $5 nghìn tỷ',
      'Quản lý vốn khởi đầu cho các ETF mới ra mắt, làm việc liên chức năng để đảm bảo vốn khởi động',
      'Cấu trúc các công cụ phái sinh để trung hòa rủi ro thị trường cho sản phẩm ETF mới',
    ],
  },
  {
    company: 'KCC Capital Partners',
    role: 'Winter Investment Banking Analyst',
    roleVi: 'Chuyên viên Phân tích Ngân hàng Đầu tư Mùa Đông',
    location: 'Newport Beach, CA',
    locationVi: 'Newport Beach, CA',
    dates: 'Nov 2025 – Feb 2026',
    datesVi: 'Tháng 11/2025 – Tháng 2/2026',
    logo: 'https://cdn.magicpatterns.com/uploads/x6dqcwkQYZN597sGaNFJGX/KCC_Capital_loog.webp',
    description: [
      'Analyzed a $35M secured convertible note for a P&C carrier acquisition under a $2.5B roll-up strategy',
      'Utilized Python to build a pipeline of 200+ institutional capital providers to support financing and acquisition',
      'Performed comprehensive financial modeling and due diligence for insurance sector transactions',
    ],
    descriptionVi: [
      'Phân tích trái phiếu chuyển đổi có bảo đảm $35M cho việc mua lại công ty bảo hiểm P&C trong chiến lược tổng hợp $2.5B',
      'Sử dụng Python để xây dựng pipeline 200+ nhà cung cấp vốn tổ chức để hỗ trợ tài trợ và mua lại',
      'Thực hiện mô hình tài chính toàn diện và thẩm định cho các giao dịch trong lĩnh vực bảo hiểm',
    ],
  },
  {
    company: 'Orient Commercial Bank',
    role: 'FX Sales & Trading Summer Analyst',
    roleVi: 'Chuyên viên Phân tích Giao dịch Ngoại hối Mùa Hè',
    location: 'Ho Chi Minh City, VN',
    locationVi: 'Thành phố Hồ Chí Minh, VN',
    dates: 'Jul 2025 – Aug 2025',
    datesVi: 'Tháng 7/2025 – Tháng 8/2025',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bgXvfaxuk8kt8mhmEEFRfu/OCB_logo.webp',
    description: [
      'Produced 10+ weekly interbank FX rate and G7 currency market reports, directly supporting trading decisions',
      'Synthesized macroeconomic data via Bloomberg Terminal to deliver actionable trends to institutional & UHNWI clients',
      'Assisted structure USD $49M in client hedging solutions using forwards and custom risk strategies',
    ],
    descriptionVi: [
      'Lập 10+ báo cáo tỷ giá liên ngân hàng và thị trường tiền tệ G7 hàng tuần, hỗ trợ trực tiếp quyết định giao dịch',
      'Tổng hợp dữ liệu kinh tế vĩ mô qua Bloomberg Terminal để cung cấp xu hướng có thể hành động cho khách hàng tổ chức và UHNWI',
      'Hỗ trợ cấu trúc $49M USD giải pháp phòng ngừa rủi ro cho khách hàng sử dụng hợp đồng kỳ hạn và chiến lược rủi ro tùy chỉnh',
    ],
  },
  {
    company: 'Ho Chi Minh City Finance and Investment SOE',
    role: 'Public Investment & Credit Intern',
    roleVi: 'Thực tập sinh Đầu tư Công & Tín dụng',
    location: 'Ho Chi Minh City, VN',
    locationVi: 'Thành phố Hồ Chí Minh, VN',
    dates: 'Apr 2025 – Jun 2025',
    datesVi: 'Tháng 4/2025 – Tháng 6/2025',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bEZT63G8jccsjSrsA8C1Ef/HFIC_logo.png',
    description: [
      'Analyzed real estate developer & auto manufacturer to uncover potential corporate fraud risks, built DCF valuations',
      'Delivered divestment reports to investment team and Board of Directors',
      "Researched Vietopia's operational efficiency and delivered investment performance reports",
      'Assisted structure USD $20M in loan packages for three public institutions via partnered banks & agencies',
    ],
    descriptionVi: [
      'Phân tích nhà phát triển bất động sản và nhà sản xuất ô tô để phát hiện rủi ro gian lận doanh nghiệp tiềm ẩn, xây dựng định giá DCF',
      'Cung cấp báo cáo thoái vốn cho đội ngũ đầu tư và Hội đồng Quản trị',
      'Nghiên cứu hiệu quả hoạt động của Vietopia và cung cấp báo cáo hiệu suất đầu tư',
      'Hỗ trợ cấu trúc $20M USD gói vay cho ba tổ chức công qua các ngân hàng và cơ quan đối tác',
    ],
  },
  {
    company: 'Cavalina Property Group',
    role: 'Spring Real Estate Private Equity Intern',
    roleVi: 'Thực tập sinh Quỹ Đầu tư Bất động sản Mùa Xuân',
    location: 'Philadelphia, PA',
    locationVi: 'Philadelphia, PA',
    dates: 'Feb 2025 – Apr 2025',
    datesVi: 'Tháng 2/2025 – Tháng 4/2025',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kPFEsGkCfPDiDeDkuRGQqE/Cavalina_property.jpg',
    description: [
      'Sourced and underwrote 3+ distressed and value-add residential & commercial deals, driving new investments',
      'Negotiated wholesale contract 22.5% below market for University Park SFR through creative financing',
      'Built comps, pro forma/T-12 extend models for $400M USD mixed-use project in NJ; leveraged PropStream',
    ],
    descriptionVi: [
      'Tìm nguồn và thẩm định hơn 3 giao dịch bất động sản dân cư và thương mại gặp khó khăn và tăng giá trị, thúc đẩy đầu tư mới',
      'Đàm phán hợp đồng bán buôn thấp hơn thị trường 22.5% cho SFR University Park thông qua tài trợ sáng tạo',
      'Xây dựng comps, mô hình pro forma/T-12 extend cho dự án hỗn hợp $400M USD tại NJ; sử dụng PropStream',
    ],
  },
  {
    company: 'VinaCapital Group',
    role: 'Summer Equity Research & Investment Intern',
    roleVi: 'Thực tập sinh Nghiên cứu Cổ phiếu & Đầu tư Mùa Hè',
    location: 'Ho Chi Minh City, VN',
    locationVi: 'Thành phố Hồ Chí Minh, VN',
    dates: 'May 2024 – Aug 2024',
    datesVi: 'Tháng 5/2024 – Tháng 8/2024',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/69Gfi9nZCzPf22b9ez85ro/VinaCapital_Logo.png',
    description: [
      'Analyzed 5 Vietnamese industrial companies and macro impacts of Chinese steel cycles and U.S./EU policy',
      'Built and presented multi-asset allocation model (Equities, Derivatives, Bonds, Real Estate) to Managing Director',
      "Built top-down macro capital flow forecast model projecting USD $200M+ inflows into Vietnam's markets",
    ],
    descriptionVi: [
      'Phân tích 5 công ty công nghiệp Việt Nam và tác động vĩ mô của chu kỳ thép Trung Quốc và chính sách Mỹ/EU',
      'Xây dựng và trình bày mô hình phân bổ tài sản đa dạng (Cổ phiếu, Phái sinh, Trái phiếu, Bất động sản) cho Giám đốc Điều hành',
      'Xây dựng mô hình dự báo dòng vốn vĩ mô từ trên xuống dự đoán hơn $200M USD dòng vốn vào thị trường Việt Nam',
    ],
  },
]

export const projectsData = [
  {
    title: 'AidWorks Foundation',
    titleVi: 'Quỹ AidWorks',
    role: 'Founder & CEO',
    roleVi: 'Người Sáng Lập & CEO',
    description:
      'Raised $13,500+ donations annually to serve 3500+ individuals through 120+ registered volunteers and 14+ institution partners.',
    descriptionVi:
      'Gây quỹ hơn $13,500 hàng năm để phục vụ hơn 3500 cá nhân thông qua hơn 120 tình nguyện viên đăng ký và 14+ đối tác tổ chức.',
    image:
      'https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
    link: '#',
  },
  {
    title: 'Northeastern Investment Banking Group',
    titleVi: 'Nhóm Ngân Hàng Đầu Tư Northeastern',
    role: 'Vice President',
    roleVi: 'Phó Chủ Tịch',
    description:
      'Served across all key functions, grew the club to 30+ active members and educated 40+ students on M&A process.',
    descriptionVi:
      'Phục vụ trong tất cả các chức năng chính, phát triển câu lạc bộ lên hơn 30 thành viên tích cực và đào tạo hơn 40 sinh viên về quy trình M&A.',
    image:
      'https://images.unsplash.com/photo-1591696205602-2f950c417cb9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
    link: '#',
  },
  {
    title: 'Vu A Dinh Scholarship Fund',
    titleVi: 'Quỹ Học Bổng Vừ A Dính',
    role: 'Deputy Chief External Relations Officer',
    roleVi: 'Phó Giám Đốc Đối Ngoại',
    description:
      'Handled USD$18M donations, maintained 120+ corporate partners, spearheaded 2 major events to support veterans.',
    descriptionVi:
      'Quản lý $18M tiền quyên góp, duy trì hơn 120 đối tác doanh nghiệp, dẫn đầu 2 sự kiện lớn để hỗ trợ cựu chiến binh.',
    image:
      'https://images.unsplash.com/photo-1577896851231-70ef18881754?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
    link: '#',
  },
  {
    title: 'Goldman Sachs 2025 Possibilities Summit',
    titleVi: 'Hội Nghị Possibilities 2025 của Goldman Sachs',
    role: 'Participant',
    roleVi: 'Người Tham Gia',
    description:
      'Selected for exclusive program providing insight into investment banking and financial markets.',
    descriptionVi:
      'Được chọn cho chương trình độc quyền cung cấp cái nhìn sâu sắc về ngân hàng đầu tư và thị trường tài chính.',
    image:
      'https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
    link: '#',
  },
]

export const leadershipData = {
  nonprofit: [
    {
      organization: 'AidWorks Foundation',
      organizationVi: 'Quỹ AidWorks',
      role: 'Founder & CEO',
      roleVi: 'Người Sáng Lập & CEO',
      description:
        'Raised $13,500+ donations annually to serve 3500+ individuals through 100+ registered volunteers and 14+ institution partners.',
      descriptionVi:
        'Gây quỹ hơn $13,500 hàng năm để phục vụ hơn 3500 cá nhân thông qua hơn 100 tình nguyện viên đăng ký và 14+ đối tác tổ chức.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/83Ws5PExbShxEko1K2171B/AidWorks_Logo.png',
    },
    {
      organization: 'Vu A Dinh Scholarship Fund',
      organizationVi: 'Quỹ Học Bổng Vừ A Dính',
      role: 'Deputy Chief External Relations Officer',
      roleVi: 'Phó Giám Đốc Đối Ngoại',
      description:
        'Handled 471B VND ($18M) donations, maintained 120+ corporate partners, spearheaded 2 major events to support veterans.',
      descriptionVi:
        'Quản lý 471 tỷ VND (18 triệu USD) tiền quyên góp, duy trì hơn 120 đối tác doanh nghiệp, dẫn đầu 2 sự kiện lớn để hỗ trợ cựu chiến binh.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/5i1QqdVxMMZHJd3vprdEDY/Vu_A_Dinh_Logo.jpg',
    },
  ],
  university: [
    {
      organization: 'Northeastern Investment Banking Group',
      organizationVi: 'Nhóm Ngân Hàng Đầu Tư Northeastern',
      role: 'Vice President',
      roleVi: 'Phó Chủ Tịch',
      description:
        'Served across all key functions, grew the club to 30+ active members and educated 40+ students on M&A process.',
      descriptionVi:
        'Phục vụ trong tất cả các chức năng chính, phát triển câu lạc bộ lên hơn 30 thành viên tích cực và đào tạo hơn 40 sinh viên về quy trình M&A.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/kGUSAPgUWXiedLVNceKZ5W/NIBG_Logo.png',
    },
    {
      organization: 'Goldman Sachs',
      organizationVi: 'Goldman Sachs',
      role: 'Possibilities Summit Participant',
      roleVi: 'Người Tham Gia Hội Nghị Possibilities',
      description:
        'Selected for exclusive program providing insight into investment banking and financial markets.',
      descriptionVi:
        'Được chọn cho chương trình độc quyền cung cấp cái nhìn sâu sắc về ngân hàng đầu tư và thị trường tài chính.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/2pvq5grFQhQzVVpAS7yvGH/Goldman_Sachs_logo.png',
    },
    {
      organization: 'DECA',
      organizationVi: 'DECA',
      role: 'International Finalist',
      roleVi: 'Người Vào Chung Kết Quốc Tế',
      description:
        'DECA International Finalist (x1), DECA State Champions (x2), DECA Regional Champions (x2).',
      descriptionVi:
        'Người vào chung kết DECA Quốc tế (x1), Vô địch DECA Tiểu bang (x2), Vô địch DECA Khu vực (x2).',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/mEymbFb5Ffw8dSyzGKVyU1/DECA_logo.png',
    },
    {
      organization: 'PeakSpan Capital',
      organizationVi: 'PeakSpan Capital',
      role: 'Growth Equity Immersion Participant',
      roleVi: 'Người Tham Gia Chương Trình Đắm Chìm Vốn Cổ Phần Tăng Trưởng',
      description:
        'Selected for PeakSpan Capital Growth Equity Immersion program to gain hands-on experience in growth equity investing.',
      descriptionVi:
        'Được chọn cho chương trình Đắm Chìm Vốn Cổ Phần Tăng Trưởng của PeakSpan Capital để có kinh nghiệm thực tế trong đầu tư vốn cổ phần tăng trưởng.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/kPnTF9B887piK4FUCaGbXR/PeakSpan_Logo.png',
    },
  ],
}

export const companyLogos = [
  {
    name: 'State Street Investment Management',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/agta6duKEorKsUKqpfgzbc/StateStreetIM.jpg',
    role: 'Spring Asset Management Analyst',
    roleVi: 'Chuyên viên Phân tích Quản lý Tài sản Mùa Xuân',
    year: '2026',
  },
  {
    name: 'KCC Capital Partners',
    logo: 'https://cdn.magicpatterns.com/uploads/x6dqcwkQYZN597sGaNFJGX/KCC_Capital_loog.webp',
    role: 'Winter Investment Banking Analyst',
    roleVi: 'Chuyên viên Phân tích Ngân hàng Đầu tư Mùa Đông',
    year: '2025-2026',
  },
  {
    name: 'Orient Commercial Bank',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bgXvfaxuk8kt8mhmEEFRfu/OCB_logo.webp',
    role: 'FX Sales & Trading Summer Analyst',
    roleVi: 'Chuyên viên Phân tích Giao dịch Ngoại hối Mùa Hè',
    year: '2025',
  },
  {
    name: 'HFIC',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bEZT63G8jccsjSrsA8C1Ef/HFIC_logo.png',
    role: 'Public Investment & Credit Intern',
    roleVi: 'Thực tập sinh Đầu tư Công & Tín dụng',
    year: '2025',
  },
  {
    name: 'Cavalina Property Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kPFEsGkCfPDiDeDkuRGQqE/Cavalina_property.jpg',
    role: 'Spring Real Estate Private Equity Intern',
    roleVi: 'Thực tập sinh Quỹ Đầu tư Bất động sản Mùa Xuân',
    year: '2025',
  },
  {
    name: 'VinaCapital',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/69Gfi9nZCzPf22b9ez85ro/VinaCapital_Logo.png',
    role: 'Summer Equity Research & Investment Intern',
    roleVi: 'Thực tập sinh Nghiên cứu Cổ phiếu & Đầu tư Mùa Hè',
    year: '2024',
  },
]

export const educationData = {
  school: 'Northeastern University',
  location: 'Boston, MA',
  degree: 'Bachelor of Science in Business Admin: Finance',
  degreeVi: 'Cử nhân Khoa học Quản trị Kinh doanh: Tài chính',
  minor: 'Data Science',
  minorVi: 'Khoa học Dữ liệu',
  gpa: '3.8/4.0',
  dates: 'Sep 2024 – Dec 2027',
  datesVi: 'Tháng 9/2024 – Tháng 12/2027',
  honors: [
    'FIRST Scholars',
    "Dean's Scholarships",
    "Dean's List",
    'DECA International Finalist',
    'DECA State Champions (x2)',
    'DECA Regional Champions (x2)',
  ],
  honorsVi: [
    'Học giả FIRST',
    'Học bổng Hiệu trưởng',
    'Danh sách Hiệu trưởng',
    'Người vào chung kết DECA Quốc tế',
    'Vô địch DECA Tiểu bang (x2)',
    'Vô địch DECA Khu vực (x2)',
  ],
  courses: [
    'Financial Management',
    'Financial and Managerial Accounting',
    'Investments Management',
  ],
  coursesVi: [
    'Quản lý Tài chính',
    'Kế toán Tài chính và Quản trị',
    'Quản lý Đầu tư',
  ],
  certifications: [
    'Bloomberg Market Concepts',
    'CFI Financial Analysis & Fundamentals',
  ],
  certificationsVi: [
    'Khái niệm Thị trường Bloomberg',
    'Phân tích Tài chính & Cơ bản CFI',
  ],
  programs: [
    'Goldman Sachs 2025 Possibilities Summit',
    'PeakSpan Capital Growth Equity Immersion',
  ],
  programsVi: [
    'Hội nghị Possibilities 2025 của Goldman Sachs',
    'Đắm chìm Vốn Cổ phần Tăng trưởng PeakSpan Capital',
  ],
}

export const skillsData = {
  languages: ['English', 'Vietnamese'],
  languagesVi: ['Tiếng Anh', 'Tiếng Việt'],
  languagesTranslation: {
    English: {
      vietnamese: 'Tiếng Anh',
      proficiency: '100%',
    },
    Vietnamese: {
      english: 'Vietnamese',
      proficiency: '100%',
    },
  },
  technical: [
    'MS Excel',
    'MS PowerPoint',
    'MS Word',
    'Keynote',
    'Bloomberg Terminal',
    'Python',
    'JavaScript',
    'HTML',
    'CSS',
  ],
  interests: [
    'Backpacking',
    'Travel',
    'Food Exploration',
    'Watch Enthusiast',
    'Piano',
    'Netflix Shows',
  ],
  interestsVi: [
    'Du lịch Ba lô',
    'Du lịch',
    'Khám phá Ẩm thực',
    'Đam mê Đồng hồ',
    'Piano',
    'Chương trình Netflix',
  ],
}

export const contactData = {
  email: 'nguyen.trung2@northeastern.edu',
  phone: '(774) 670-6733',
  linkedin: 'linkedin.com/in/trungvtnguyen',
}

export const certificationsData = [
  {
    name: 'Bloomberg Market Concepts',
    nameVi: 'Khái niệm Thị trường Bloomberg',
    organization: 'Bloomberg',
    organizationVi: 'Bloomberg',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/amt8QY4uUXq4pXQJ5dQLRq/Bloomberg_logo.png',
    link: 'https://portal.bloombergforeducation.com/certificates/gY1XpAntfcMa1Jng2eX3q6dG',
    description:
      'Comprehensive e-learning course on financial markets and Bloomberg Terminal functionality',
    descriptionVi:
      'Khóa học e-learning toàn diện về thị trường tài chính và chức năng của Bloomberg Terminal',
  },
  {
    name: 'Financial Analysis & Fundamentals',
    nameVi: 'Phân tích Tài chính & Cơ bản',
    organization: 'Corporate Finance Institute',
    organizationVi: 'Viện Tài chính Doanh nghiệp',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4C4DwVGhvTaptFEeWmbxbp/CPI_logo.webp',
    link: 'https://credentials.corporatefinanceinstitute.com/8a55348f-f530-4e68-af28-fc0d44bc064a#acc.QGS28ywt',
    description:
      'Advanced financial analysis and modeling skills certification',
    descriptionVi:
      'Chứng chỉ kỹ năng phân tích và mô hình hóa tài chính nâng cao',
  },
  {
    name: 'Investment Banking Virtual Experience',
    nameVi: 'Kinh nghiệm Ảo về Ngân hàng Đầu tư',
    organization: 'JP Morgan Chase',
    organizationVi: 'JP Morgan Chase',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/h2uhRDbcpVnPgFYDwgiMPa/JPM_Logo.png',
    link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/JPMorgan%20Chase/YD2kY95RQxQtXxFTS_JPMorgan%20Chase_64F8QYXdHiA42ANhe_1710985177270_completion_certificate.pdf',
    description:
      "Practical investment banking skills through JP Morgan's virtual work experience program",
    descriptionVi:
      'Kỹ năng ngân hàng đầu tư thực tế thông qua chương trình kinh nghiệm làm việc ảo của JP Morgan',
  },
  {
    name: 'Strategy Consulting Virtual Experience',
    nameVi: 'Kinh nghiệm Ảo về Tư vấn Chiến lược',
    organization: 'Boston Consulting Group',
    organizationVi: 'Boston Consulting Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eH48qhT7ZzGm3fr611QWHe/BCG_logo.png',
    link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/BCG%20/4Rfzeut8gXmNwfxXv_BCG%20_64F8QYXdHiA42ANhe_1710727242314_completion_certificate.pdf',
    description:
      'Strategic consulting methodology and problem-solving certification',
    descriptionVi:
      'Chứng chỉ phương pháp tư vấn chiến lược và giải quyết vấn đề',
  },
  {
    name: 'Investment Banking Virtual Experience',
    nameVi: 'Kinh nghiệm Ảo về Ngân hàng Đầu tư',
    organization: 'Goldman Sachs',
    organizationVi: 'Goldman Sachs',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m42bp4PAAecz2WmNFXpK9r/GS_logo.png',
    link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Goldman%20Sachs/NPdeQ43o8P9HJmJzg_Goldman%20Sachs_64F8QYXdHiA42ANhe_1711039161413_completion_certificate.pdf',
    description:
      "Comprehensive investment banking skills through Goldman Sachs' virtual program",
    descriptionVi:
      'Kỹ năng ngân hàng đầu tư toàn diện thông qua chương trình ảo của Goldman Sachs',
  },
  {
    name: 'First Aid Certification',
    nameVi: 'Chứng chỉ Sơ cứu',
    organization: 'American Red Cross',
    organizationVi: 'Hội Chữ thập đỏ Hoa Kỳ',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fZquAM8crf7AVcBEGK71A9/Red_Cross_logo.png',
    link: 'https://www.redcross.org/take-a-class/qrcode?certnumber=00JK3FV',
    description:
      'Certified in first aid, emergency response, and life-saving techniques',
    descriptionVi:
      'Được chứng nhận về sơ cứu, ứng phó khẩn cấp và kỹ thuật cứu sinh',
  },
]

export const statsData = [
  {
    id: 'stats-section',
    title: 'My Achievements',
    titleVi: 'Thành tựu của tôi',
    stats: [
      {
        id: 'kcc-convertible-bonds',
        label: 'KCC Capital: Convertible Bonds Analyzed',
        labelVi: 'KCC Capital: Trái phiếu Chuyển đổi Phân tích',
        value: 35,
        suffix: 'M USD',
        alternateValue: 924,
        alternateSuffix: 'B VND',
        hasCurrencyToggle: true,
        duration: 5.5,
      },
      {
        id: 'vuadinh-donations',
        label: 'Vu A Dinh: Donations Handled',
        labelVi: 'Vừ A Dính: Quản lý Quyên góp',
        value: 471,
        suffix: 'B VND',
        alternateValue: 17.8,
        alternateSuffix: 'M USD',
        hasCurrencyToggle: true,
        duration: 6,
      },
      {
        id: 'vuadinh-donors',
        label: 'Vu A Dinh: Corporate Donors',
        labelVi: 'Vừ A Dính: Nhà tài trợ Doanh nghiệp',
        value: 120,
        suffix: '+',
        duration: 5,
      },
      {
        id: 'total-people-impacted',
        label: 'Total People Impacted',
        labelVi: 'Tổng số Người Được Hỗ Trợ',
        value: 93500,
        suffix: '+',
        duration: 7,
      },
      {
        id: 'ocb-hedging',
        label: 'OCB: Client Hedging Solutions',
        labelVi: 'OCB: Giải pháp Phòng ngừa rủi ro Khách hàng',
        value: 49,
        suffix: 'M USD',
        alternateValue: 1.25,
        alternateSuffix: 'T VND',
        hasCurrencyToggle: true,
        duration: 6,
      },
      {
        id: 'hfic-loans',
        label: 'HFIC: Loan Packages',
        labelVi: 'HFIC: Gói vay',
        value: 20,
        suffix: 'M USD',
        alternateValue: 400,
        alternateSuffix: 'B VND',
        hasCurrencyToggle: true,
        duration: 5.5,
      },
      {
        id: 'cavalina-project',
        label: 'Cavalina: Mixed-Use Project Model',
        labelVi: 'Cavalina: Mô hình Dự án Đa dụng',
        value: 400,
        suffix: 'M USD',
        alternateValue: 10.56,
        alternateSuffix: 'T VND',
        hasCurrencyToggle: true,
        duration: 5.5,
      },
      {
        id: 'aidworks-fundraising',
        label: 'AidWorks: Annual Fundraising',
        labelVi: 'AidWorks: Gây quỹ Hàng năm',
        value: 13.5,
        suffix: 'K USD',
        alternateValue: 356.4,
        alternateSuffix: 'M VND',
        hasCurrencyToggle: true,
        duration: 5,
      },
      {
        id: 'aidworks-volunteers',
        label: 'AidWorks: Volunteers',
        labelVi: 'AidWorks: Tình nguyện viên',
        value: 100,
        suffix: '+',
        duration: 5,
      },
      {
        id: 'people-impacted',
        label: 'AidWorks: People Directly Impacted',
        labelVi: 'AidWorks: Người Được Hỗ Trợ Trực tiếp',
        value: 3500,
        suffix: '+',
        duration: 6,
      },
      {
        id: 'social-impressions',
        label: 'AidWorks: Social Media Impressions',
        labelVi: 'AidWorks: Lượt Tiếp cận Mạng xã hội',
        value: 100000,
        suffix: '+',
        duration: 7,
      },
      {
        id: 'nibg-members',
        label: 'NIBG: Club Members',
        labelVi: 'NIBG: Thành viên Câu lạc bộ',
        value: 30,
        suffix: '+',
        duration: 5,
      },
      {
        id: 'nibg-students',
        label: 'NIBG: Students Educated',
        labelVi: 'NIBG: Sinh viên Đào tạo',
        value: 40,
        suffix: '+',
        duration: 5,
      },
      {
        id: 'gpa',
        label: 'GPA',
        labelVi: 'GPA',
        value: 3.8,
        suffix: '/4.0',
        duration: 5,
      },
    ],
  },
]
